import api from '../api';
import { AxiosError } from 'axios';
import { RegistrationValidation, ParamsBodySearchPersonal } from 'utils/typeServices';
interface ErrorResponse {
    Data: string;
}

export const GetSearchPersonData = async ({ person, schedule, token }: ParamsBodySearchPersonal) => {
    try {
        const { data } = await api.get<{ Data: RegistrationValidation; }>(`v1/Cliente/AgendamentoBuscarDadosPessoa?person=${person}&schedule=${schedule}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error: unknown) {
        const axiosError = error as AxiosError<ErrorResponse>;
        return { data: null, specificError: axiosError?.response?.data?.Data === 'Data de nascimento obrigatória.' };
    }
}
